/// <summary name='cafm.timezone' type='Object'>Container object for CAFM timezone code</summary>
cafm.timezone = {

    /// <field name='timeZoneAction' type='cafm.actions.Action'>The forms time zone action</field>
    timeZoneAction: function () {
        return new cafm.actions.Action({
            id: 'ChangeTimeZone',
            elementId: 'timeZoneForm',
            loaderSelector: '#timeZoneBtnSubmit',
            preventValidationMessage: true,
            statusCodeFuncs: {
                200: function (r, s, m, a) {

                    //$('#loginForm').fadeOut();
                }
            }
        })
    },

    prepareTimeZone: function () {
        var vm = {};

        //vm.TimeZoneIdDropdown = "(UTC +05:00) Asia/Yekaterinburg";
        var tz = cafm.timezone.timeZoneAction();
        var tzc = $('#timeZoneForm'); 

        tzc.bindViewModel({
            viewModel: vm,
            action: tz,
            targPnl: tzc
        });

        tzc.prepareForm().fadeIn();
    },

    saveSessionTimeZone: function (sessionTimeZone, redirect = true) {

        //save the session time zone as a default one
        cafm.actions.execute({
            url: cafm.url.api('TimeZone/SaveDefaultTimeZone?choosenTimeZone=' + sessionTimeZone),
            sync: true,
            success: function (result) {
                console.log("Success");
            },
            error: function () {
                console.log("Error setting the default timezone");
            }
        });

        //redirect to main page
        if (redirect === true) {
            cafm.util.callFunctionAsync({
                func() {
                    if (!isDefined(cafm.auth.loginRedirectUrl)) {
                        window.location = cafm.url.get();
                    }
                    else {
                        cafm.url.set(decodeURIComponent(cafm.auth.loginRedirectUrl));
                    }
                },
                timeout: 1000
            });
        }
    },

    cacheTimeZone: function (tz) {
        cafm.cache.session.set(cafm.res.consts.CacheKey_TimeZone, tz);
        //This is needed to use TimeZone in window.open with target_Blank
        cafm.cache.set(cafm.res.consts.CacheKey_LastTimeZoneSelection, tz);
    },

    condition: {
        submit: function (e) {
            var sessionTimeZone = $('#TimeZoneID').val();

            //set TimeZone name in the session
            cafm.timezone.cacheTimeZone(sessionTimeZone);

            //save the session time zone
            cafm.timezone.saveSessionTimeZone(sessionTimeZone);
          
        },
        cancel: function (e) {
            //If Cancel go to Login screen
            if (cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Forms)
                window.location = cafm.url.get('Authentication/Login');
            else {
                cafm.web.closeWindow();
            }
            cafm.cache.clearAll([cafm.res.consts.CacheKey_TimeZone]);
        }
    }
}